/* ═══════════════════════════════════════════
   BAU BUNDLE — Renderer v4.0
   Front D-Ring automatico
   Ordine definitivo: Pettorina → Guinzaglio → Portabustine → BauBook → BauRing
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  var BauBundleRenderer = {
    container: null,

    init: function (selector) {
      this.container = document.querySelector(selector || '#bau-bundle-root');
      if (!this.container) return;
      var self = this;
      window.addEventListener('bau-bundle:state-changed', function (e) { self.render(e.detail.state); });
      var state = window.BauBundleState ? window.BauBundleState.getState() : null;
      if (state) this.render(state);
    },

    render: function (state) {
      if (!this.container) return;
      var products = window.BauBundleProducts;
      if (!products || !products.isReady()) return;

      var html = '';
      html += this._renderTitle();
      html += this._renderPaidCard('pettorina', state);
      html += this._renderConnector();
      html += this._renderPaidCard('guinzaglio', state);
      html += this._renderConnector();
      html += this._renderFreeSelectableCard('portabustine', state);
      html += this._renderConnector();
      html += this._renderFreeStaticCard('ebook', state);
      html += this._renderConnector();
      html += this._renderFrontDRingCard(state);
      html += this._renderTotals(state);
      html += this._renderCTA();
      this.container.innerHTML = html;
    },

    _renderTitle: function () {
      return '<div class="bau-bundle__title">' +
        '<span class="bau-bundle__title-icon">🛡️</span>' +
        '<span class="bau-bundle__title-text">Più Proteggi, Più Risparmi.</span>' +
      '</div>';
    },

    _renderPaidCard: function (key, state) {
      var products = window.BauBundleProducts;
      var resolveKey = (key === 'guinzaglio' && state.activeLeashKey) ? state.activeLeashKey : key;
      var product = products.getProduct(resolveKey);
      var sel = state.selections[key];
      if (!product || !sel) return '';

      var image = sel.image || product.featuredImage || '';
      var isOpen = state.openDropdown === key;
      var hasVariants = (product.variants || []).filter(function (v) { return v.available; }).length > 1;
      var label = sel.color ? (sel.size ? sel.color + ' / ' + sel.size : sel.color) : 'Seleziona variante';
      var trigger = hasVariants ? this._renderTrigger(key, label, isOpen) : '';
      var dropdown = (isOpen && hasVariants) ? this._renderDropdown(key, state) : '';

      return '<div class="bau-bundle__card' + (isOpen ? ' bau-bundle__card--dropdown-open' : '') + '" data-product-key="' + key + '">' +
        '<div class="bau-bundle__card-main">' +
          '<div class="bau-bundle__card-image"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></div>' +
          '<div class="bau-bundle__card-info">' +
            '<div class="bau-bundle__card-name"><a href="/products/' + escapeHtml(product.handle) + '" class="bau-bundle__card-link">' + escapeHtml(product.title) + '</a></div>' +
            '<div class="bau-bundle__card-pricing"><span class="bau-bundle__price--current">€' + Number(sel.price || 0).toFixed(2) + '</span></div>' +
          '</div>' +
        '</div>' + trigger + dropdown +
      '</div>';
    },


    _freePricing: function (compareAt) {
      compareAt = Number(compareAt || 0);
      return '<span class="bau-bundle__price--old">€' + compareAt.toFixed(2) + '</span>' +
        '<span class="bau-bundle__price--current bau-bundle__price--free">GRATIS</span>';
    },

    _freeBadge: function (compareAt) {
      compareAt = Number(compareAt || 0);
      if (!compareAt) return '';
      return '<ul class="bau-bundle__badge-list" role="list"><li class="badge">' +
        '<svg class="bau-bundle__discount-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M20 12 12 20 4 12V4h8l8 8Z"/><circle cx="8.5" cy="8.5" r="1.25"/>' +
        '</svg>' +
        'BAUBUNDLE (-€' + compareAt.toFixed(2) + ')</li></ul>';
    },

    _renderFreeSelectableCard: function (key, state) {
      var products = window.BauBundleProducts;
      var product = products.getProduct(key);
      var sel = state.selections[key];
      if (!product || !sel) return '';

      var image = sel.image || product.featuredImage || '';
      var isOpen = state.openDropdown === key;
      var hasVariants = (product.variants || []).filter(function (v) { return v.available; }).length > 1;
      var label = sel.color ? (sel.size ? sel.color + ' / ' + sel.size : sel.color) : 'Seleziona variante';
      var compareAt = Number(sel.compareAtPrice || sel.price || 9.99);
      var trigger = hasVariants ? this._renderTrigger(key, label, isOpen) : '';
      var dropdown = (isOpen && hasVariants) ? this._renderDropdown(key, state) : '';

      return '<div class="bau-bundle__card bau-bundle__card--free' + (isOpen ? ' bau-bundle__card--dropdown-open' : '') + '" data-product-key="' + key + '">' +
        '<div class="bau-bundle__card-main">' +
          '<div class="bau-bundle__card-image"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></div>' +
          '<div class="bau-bundle__card-info"><div class="bau-bundle__card-name"><a href="/products/' + escapeHtml(product.handle) + '" class="bau-bundle__card-link">' + escapeHtml(product.title) + '</a></div>' +
          '<div class="bau-bundle__card-pricing">' + this._freePricing(compareAt) + '</div>' + this._freeBadge(compareAt) + '</div>' +
          '<div class="bau-bundle__card-ribbon"><span>GRATIS</span></div>' +
        '</div>' + trigger + dropdown +
      '</div>';
    },

    _renderFreeStaticCard: function (key, state) {
      var products = window.BauBundleProducts;
      var product = products.getProduct(key);
      var fp = state.freeProducts[key];
      if (!product || !fp) return '';
      var image = fp.image || product.featuredImage || '';
      var compareAt = Number(fp.compareAtPrice || 0);

      return '<div class="bau-bundle__card bau-bundle__card--free" data-product-key="' + key + '">' +
        '<div class="bau-bundle__card-main">' +
          '<div class="bau-bundle__card-image"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></div>' +
          '<div class="bau-bundle__card-info"><div class="bau-bundle__card-name"><a href="/products/' + escapeHtml(product.handle) + '" class="bau-bundle__card-link">' + escapeHtml(product.title) + '</a></div>' +
          '<div class="bau-bundle__card-pricing">' + this._freePricing(compareAt) + '</div>' + this._freeBadge(compareAt) + '</div>' +
          '<div class="bau-bundle__card-ribbon"><span>GRATIS</span></div>' +
        '</div>' +
      '</div>';
    },

    _renderFrontDRingCard: function (state) {
      var products = window.BauBundleProducts;
      var product = products.getProduct('front_d_ring');
      var fp = state.freeProducts.front_d_ring;
      if (!product || !fp || !fp.variantId) return '';
      var image = fp.image || product.featuredImage || '';

      return '<div class="bau-bundle__card bau-bundle__card--free" data-product-key="front_d_ring">' +
        '<div class="bau-bundle__card-main">' +
          '<div class="bau-bundle__card-image"><img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy"></div>' +
          '<div class="bau-bundle__card-info"><div class="bau-bundle__card-name"><a href="/products/' + escapeHtml(product.handle) + '" class="bau-bundle__card-link">' + escapeHtml(product.title) + '</a></div>' +
          '<div class="bau-bundle__card-pricing">' + this._freePricing(9.99) + '</div>' + this._freeBadge(9.99) + '</div>' +
          '<div class="bau-bundle__card-ribbon"><span>GRATIS</span></div>' +
        '</div>' +
      '</div>';
    },

    _renderTrigger: function (key, label, isOpen) {
      return '<button type="button" class="bau-bundle__variant-trigger" data-product-key="' + key + '" aria-expanded="' + isOpen + '">' +
        '<span class="bau-bundle__variant-trigger-text">' + escapeHtml(label || 'Seleziona variante') + '</span>' +
        '<svg class="bau-bundle__variant-trigger-arrow' + (isOpen ? ' bau-bundle__variant-trigger-arrow--open' : '') + '" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="16" height="16"><path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5"/></svg>' +
      '</button>';
    },

    _renderDropdown: function (key, state) {
      var products = window.BauBundleProducts;
      var resolveKey = (key === 'guinzaglio' && state.activeLeashKey) ? state.activeLeashKey : key;
      var product = products.getProduct(resolveKey);
      if (!product) return '';
      var colors = products.getColors(resolveKey);
      var currentSel = state.selections[key] || {};
      var activeColor = currentSel.color || (colors[0] ? colors[0].name : '');
      var activeSizes = products.getSizesForColor(resolveKey, activeColor);

      var colorHtml = colors.map(function (c) {
        var active = c.name === activeColor;
        return '<button type="button" class="bau-bundle__color-chip' + (active ? ' bau-bundle__color-chip--selected' : '') + '"' +
          ' data-product-key="' + key + '" data-color="' + escapeHtml(c.name) + '">' +
          '<span class="bau-bundle__color-chip-image"><img src="' + escapeHtml(c.image || '') + '" alt="" loading="lazy"></span>' +
          '<span class="bau-bundle__color-chip-label">' + escapeHtml(c.name) + '</span>' +
        '</button>';
      }).join('');

      var sizeHtml = activeSizes.length > 1 ? '<div class="bau-bundle__size-line">' + activeSizes.map(function (sz) {
        var selected = currentSel.size === sz.size;
        return '<button type="button" class="bau-bundle__size-btn' + (selected ? ' bau-bundle__size-btn--selected' : '') + (sz.available ? '' : ' bau-bundle__size-btn--disabled') + '"' +
          ' data-product-key="' + key + '" data-color="' + escapeHtml(activeColor) + '" data-size="' + escapeHtml(sz.size || '') + '"' +
          (sz.available ? '' : ' disabled') + '>' + escapeHtml(sz.size || 'Unica') + '</button>';
      }).join('') + '</div>' : '';

      return '<div class="bau-bundle__dropdown" data-product-key="' + key + '"><div class="bau-bundle__dropdown-inner bau-bundle__picker">' +
        '<div class="bau-bundle__picker-label">Colore</div><div class="bau-bundle__color-line">' + colorHtml + '</div>' +
        (sizeHtml ? '<div class="bau-bundle__picker-label bau-bundle__picker-label--size">Taglia</div>' + sizeHtml : '') +
      '</div></div>';
    },

    _renderConnector: function () {
      return '<div class="bau-bundle__connector"><div class="bau-bundle__connector-circle"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/></svg></div></div>';
    },

    _renderTotals: function (state) {
      var savingsHtml = state.savings > 0 ? '<span class="bau-bundle__totals-savings">Risparmi €' + Number(state.savings).toFixed(2) + '</span>' : '';
      return '<div class="bau-bundle__totals"><div class="bau-bundle__totals-left"><span class="bau-bundle__totals-label">Totale</span>' + savingsHtml + '</div>' +
        '<div class="bau-bundle__totals-prices"><span class="bau-bundle__totals-full">€' + Number(state.fullPrice || 0).toFixed(2) + '</span><span class="bau-bundle__totals-final">€' + Number(state.subtotal || 0).toFixed(2) + '</span></div></div>';
    },

    _renderCTA: function () {
      return '<button type="button" class="bau-bundle__cta" id="bauBundleAddToCart"><span class="bau-bundle__cta-text">Completa la Protezione</span></button>' +
        '<p id="bauBundleError" role="alert" style="font-size:12px;color:#b42318;margin:0"></p>';
    }
  };

  window.BauBundleRenderer = BauBundleRenderer;
})();
